import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextareaAutosize
} from '@mui/material';
import axios from 'axios';
import PropTypes from 'prop-types';
import { API_BASE_URL, LAMBDA_BASE_URL } from "../../../constants";
import { getDomainIdSync } from 'utils/utils';
import ReactQuill from 'react-quill';

const AddAnswer = ({ apiEndpoint, id, onSuccess }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editedText, setEditedText] = useState('');
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const openDialog = () => {
    setIsDialogOpen(true);
    setEditedText('');
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    setEditedText('');
    setIsConfirmationOpen(false);
  };

  const openConfirmationDialog = () => {
    if (editedText.trim()) setIsConfirmationOpen(true);
  };

  const closeConfirmationDialog = () => {
    setIsConfirmationOpen(false);
  };

  const handleSave = async () => {
    try {
      const domainId = getDomainIdSync();
      const response = await axios.patch(`${LAMBDA_BASE_URL}/edit-answer/${id}`, {
        id,
        answer: editedText,
      }, {
        headers: {
          'DOMAIN-TOKEN': domainId
        }
      });

      if (response.status === 200) {
        if (onSuccess) onSuccess();
        closeDialog();
      }
    } catch (error) {
      console.error("Error saving the answer:", error.response?.data || error.message);
    }
  };

  return (
    <>
      <Button
        onClick={openDialog}
        style={{
          background: '#219297',
          color: 'white',
          border: 'none',
          fontWeight: 500,
          fontSize: '10px',
          lineHeight: '12px',
          borderRadius: '4px',
          padding: '8px'
        }}
      >
        Add Answer
      </Button>

      <Dialog
        open={isDialogOpen}
        onClose={closeDialog}
        fullWidth
        maxWidth="md"
        
         PaperProps={{
        sx: {
         
          position: "absolute",
        
       
          
        },
        }}
      >
        <DialogTitle>Add Answer</DialogTitle>
        <DialogContent dividers sx={{ padding: "32px" }}>
         <ReactQuill
                      theme="snow"
                      value={editedText}
                      onChange={setEditedText}
                      style={{
                        minHeight: "200px",
                      }}
                      placeholder="Enter your answer..."
                    />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={openConfirmationDialog}
            variant="contained"
            sx={{
              background: "teal",
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { background: "teal" }
            }}
          >
            Save
          </Button>
          <Button  sx={{color:"#219297"}} onClick={closeDialog}>Cancel</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isConfirmationOpen} onClose={closeConfirmationDialog} fullWidth maxWidth="sm">
        <DialogTitle>Confirm Save</DialogTitle>
        <DialogContent sx={{ paddingTop: "16px" }}>
          <p>Are you sure you want to save this answer?</p>
        </DialogContent>
        <DialogActions>
          <Button sx={{color:"#219297"}} onClick={closeConfirmationDialog}>Cancel</Button>
          <Button
            onClick={handleSave}
            variant="contained"
            sx={{
              background: "teal",
              color: "#fff",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { background: "teal" }
            }}
          >
            Yes, Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

AddAnswer.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  apiEndpoint: PropTypes.string,
  onSuccess: PropTypes.func,
};

export default AddAnswer;
